<template>
  <div class="my_issue_topic" >
    <div class="list_wrap">
      <List v-model="loading" :finished="finished" @load="loadMore" finished-text="It's the end~"> 
        <div class="item" v-for="(item,index) in list" :key="index" @click="goToHotTopDetails(item)">
          <div class="item_top">
            {{item.content}}
          </div>
          <div class="item_img" v-if="item.imgUrls&&item.imgUrls.length">
            <img v-for="(mode,ind) in item.imgUrls" :key="ind" :src="mode" v-load="'oPic'" > 
          </div>
          <div class="item_tag" v-if="item.themes&&item.themes.length">
            <span  v-for="(mode,ind) in item.themes" :key="ind">#{{mode.title}}#</span>
          </div>
          <div class="item_bottom">
            <div class="state_ok" v-if="item.auditState=='PASS'">
              <div class="item_count">
                <span>{{item.viewCount}} 阅读</span>
                <span>{{item.commentCount}} 留言</span>
                <span>{{item.likeCount}} 点赞</span>
              </div>
              <p>{{item.createAt}}</p>
            </div>
            <div class="item_state" v-else>
              <div class="state0" :class="item.auditState=='NoPass'?'state-1':''">{{item.auditState=='NoPass'?'未通过':'审核中'}}</div>
              <div class="state_no" v-if="item.auditState=='NoPass'">
                <span @click.stop="delStateNoTalk(item.id)">删除</span>
                <div @click.stop="topicEdit(item)" >重新编辑</div>
              </div>
            </div>
          </div>
        </div>
        <div slot="loading" class="f-tac loading">
          <img src="@assets/img/new/icon-loading.png" />
          loading...
        </div>
        <div slot="finished" class="f-tac loading">It's the end~</div>
      </List>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import moment from "moment";
import { List } from "vant";
import { mapGetters, mapActions } from "vuex";
export default {  
  name: "my-issue-topic",
  data() {
    return {
      loading: false,   //联系我的加载状态
      finished: false,  //联系我的是否完成状态
      list: [],         //联系我的列表
      pageIndex: 0,
      pageSize:20,
      queryTalk:{},
    };
  },
  components: { List },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      exhibitionId:"getExhibitionId"
    }),
  },
  created() {
  },
  methods: {
    ...mapActions({
      delTalk:'my/delTalk',
      LinkHotPub:'linkTo/LinkHotPub',
      LinkToHotTopDetails:'linkTo/LinkToHotTopDetails'
    }),
    //去话题详情
    goToHotTopDetails(item){
      // console.log(item);
      if(item.auditState=='WAIT'){
        this.$toast('审核暂未通过')
        return 
      }
      this.LinkToHotTopDetails(item.id);
    },  
    wCount(value) {
      //过万处理
      let num = value;
      if (value > 9999) {
        //大于9999显示x.xx万
        num = Math.floor(value / 100) / 100 + "w";
      } else {
        num = value;
      }
      return num;
    },
    getList(){
      let query=gql`
      query queryTalk($query:QueryInput!){
        queryTalk(query:$query){
          hasNextPage
          indexFrom
          pageIndex
          pageSize
          items{
            auditState
            commentCount  
            content 
            createAt
            id
            imgUrls
            likeCount
            themes{
              title
              id
            }
            viewCount
          }
        }
      }`
      let where={
        "Equal":{
          "n":"memberId",
          "v":this.userInfo.inMember.memberId
        },
        "EqualB":{
          "n":"exhibitionId",
          "v":this.exhibitionId
        }
      }
      let order=[
        {
          "N":"createAt",
          "v":0
        }
      ]
      let opt={
        page:this.pageIndex,
        size:this.pageSize,
        where:JSON.stringify(where),
        order:JSON.stringify(order)
      }
      this.$apollo.addSmartQuery("queryTalk",{ 
        query:query,
        variables:{
         query:opt
        },
        fetchPolicy: 'network-only',    //清理缓存
        result(data){
          let res=JSON.parse(JSON.stringify(data.data.queryTalk));
          // let res=data.data.queryProduct;
          console.log('发布的话题',res);
          if(res.items.length){
            res.items.forEach(e => {
              e.createAt=moment(e.createAt).format('YYYY/MM/DD HH:mm:ss');
              if(e.imgUrls){
                e.imgUrls= e.imgUrls.split(';');
              }
            });
          }
          if(this.pageIndex==1){
            this.list=res.items
          }else{
            this.list=[...new Set([...this.list,...res.items])];
          }
          this.loading=false;
          if (!res.hasNextPage) {
            this.finished = true;
          }
        },
        error(err){
          this.loading=false;
          this.finished = true;
          console.log('err',err)
        }
      })
      // setTimeout(()=>{
      //   this.list=[...this.list,...this.list];
      //   this.loading=false;
      //   if(this.list.length>20){
      //     this.finished=true
      //   }
      // },1000)
    },
    loadMore(){
      if(this.finished) return;
      this.pageIndex+=1;
      this.getList();
    },
    //删除
    async delStateNoTalk(id){
      let res= await this.delTalk(id);
      if(res.result){
        this.list=this.list.filter(item => item.id!=id);
        this.$toast.success("删除成功");
      }else{
        this.$toast.fail('删除失败')
      }
    },
    //重新编辑
    topicEdit(item){
      let imgArr=[];
      if(item.imgUrls&&item.imgUrls.length){
        item.imgUrls.map(e=>{
          imgArr.push({url:e})    
        })
      }
      localStorage.setItem("content",item.content);
      localStorage.setItem("relepase",JSON.stringify(item.themes));
      if(imgArr.length){
        localStorage.setItem("Upimg",JSON.stringify(imgArr));
      }
      this.LinkHotPub({id:false,talkId:item.id})
    },
  }
};
</script>

<style scoped lang="scss">
//展品列表
.my_issue_topic{
  .list_wrap{
    .item{
      background-color: #fff;
      margin-bottom: 0.3rem;
      box-shadow: 0 0  0.1rem 0
      rgba(0, 0, 0, 0.1);
      border-radius: 0.1rem;
      padding:0.2rem;
      margin-bottom: 0.3rem;
      &:last-child{
        margin-bottom: 0;
      }
      .item_top{
        font-size: 0.26rem;
        // font-weight: bold;
        color: #333;
        line-height:0.4rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .item_img{
        display: flex;
        margin-top: .2rem;
        img{
          width: 1.1rem;
          height: 1.1rem;
          margin-right: .1rem;
          &:last-child{
            margin-right: 0;
          }
        }
      }
      .item_tag{
        margin: 0.2rem -0.1rem -0.1rem 0;
        display: flex;
        flex-wrap: wrap;
        span{
          margin-right: 0.1rem;
          margin-bottom: 0.1rem;
          display: flex;
          justify-content: center;
          align-items: center;
          min-height: .32rem;
          padding:0.06rem 0.18rem;
          background: rgba(255,85,0,0.2);
          color: #ff5500;
          border-radius: .2rem;
          font-size: 0.22rem;
          &:last-child{
            margin-right: 0;
          }
        }
      }
      .item_bottom{
        *{
          font-size: 0.22rem;
        }
        margin-top: 0.3rem;
        .state_ok{
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: #666;
          .item_count{
            span{
              margin-right:0.3rem;
              &:last-child{
                margin-right: 0;
              }
            }
           
          }
        }
        .item_state{
          display: flex;
          justify-content: space-between;
          align-items: center;
          .state0{
            color: #ff9752;
            &.state-1{
              color:#ff563a;
            }
          }
          .state_no{
            display: flex;
            align-items: center;
            span{
              color:#ff563a;
              margin-right: 0.3rem;
            }
            div{
              padding: 0.05rem 0.2rem;
              border-radius: 0.05rem;
              background: #ff954f;
              color: #fff;
            }
          }
        }
      }
    }
  }
}
.f-tac {
  text-align: center;
}
.loading {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 18px;
    height: 18px;
    display: inline-block;
    margin-right: 5px;
    animation: 1s loader-01 linear infinite;
  }
}
@keyframes loader-01 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
